import { Shape } from "./RampCanvas";

export const updateAtId = (shapes: Shape[], newShape: Shape): Shape[] => {
  const updatedShapes = shapes.filter((s) => s.id !== newShape.id);
  return [newShape, ...updatedShapes];
};
